import request from "@/utils/http";

/** Useasy 客户-坐席绑定（Django /api/useasy_agent_binding/） */
export function getUseasyAgentBinding(phone) {
  return request({
    url: `/api/useasy_agent_binding/?phone=${encodeURIComponent(phone)}`,
    method: "get",
  });
}

export function login(username, password) {
  const data = { username: username, password: password, platform: 'web' };
  return request({
    url: "/api/ainvest_login/",
    method: "post",
    data,
  });
}
export function logout() {
  // Cookie mode: browser sends auth cookies automatically; no manual token capture needed
  return request({
    url: '/api/logout/',
    method: 'post',
    data: {},
    _isRefresh: true,
  })
}
export function bind_state(username) {
  const data = { username: username };
  return request({
    url: "/v3/bind_state",
    method: "post",
    data,
  });
}
/**
 * 检测当前会话是否处于登陆检查
 */
// export function islogin() {
//   return request({
//     url: "/api/office_web/judge_login/",
//     method: "get",
//   });
// }

// /**
//  * 检测当前会话是否处于登陆检查
//  */
// export function isloginV3() {
//   return request({
//     url: '/v3/judge_login',
//     method: 'get',
//   });
// }

/**
 * 检测当前会话是否处于登陆检查
 */
export function islogin() {
  // 走 Django /api/judge_session/：token 由 Python 签发，Python 自身即权威验签方，
  // 不绕到 Java /reg/judge_login（避免公钥同步风险 + Java 宕机导致登录态误判）。
  // Django 侧已补即时冻结检查，行为与 Java 对齐。
  return request({
    url: "/api/judge_session/",
    method: "get",
    // 任何页面加载都会调用这个检查型接口，匿名访客调用它天然就是"未登录"，
    // 不该触发响应拦截器里那套"20006 → 自动刷新失败 → 跳转 /login"的逻辑
    // （那是给已登录中途掉线设计的），否则从没登录过的访客也会被强制跳走。
    _silent: true,
  }).then((res) => ({
    ...res,
    login_status: !!(res.success || res.data),
    status_code: res.status_code || (res.code + ""),
  }));
}
/**
 * 订阅选择投顾 需要改名subscribe
 * @param {String|Number} strategyid
 * @param {String|Number} classid
 */
export function choseStrategy(strategyid, classid) {
  const data = { new_strategy_id: strategyid, new_class_id: classid };
  return request({
    url: "/api/office_web/update_personal_strategy/",
    method: "post",
    data,
  });
}

/**
 * 切换自动交易启动状态
 * @param {String|Number} status_code
 */
export function toggleYidao(status_code) {
  const data = { status_code: status_code };
  return request({
    url: "/api/office_web/change_use/",
    method: "post",
    data,
  });
}

/**
 * 获取用户信息
 * @param {id:userid,token:token,username:username} data
 */
export function getUserInfofromNewServer(username) {
  const data = {
    username: username,
    nativeCode: "imAinvestcnabc",
    // phoneNumber: phoneNumber
  };
  return request({
    url: "/v3/getuserinfobn",
    method: "post",
    data,
  });
}
export function getUserInfofromOldServer(data) {
  return request({
    url: "/api/office_web/get_personal_info/",
    method: "get",
  });
}

export function customerReturnNew(username) {
  return request({
    url: `/v3/customer_return_new?u=${username}`,
    method: "get",
  });
}

/**
 * 获取投顾列表(排行榜)
 */
export function fetchStrategylist() {
  return request({
    url: "/api/office_web/get_list/",
    method: "get",
  });
}

/**
 * 获取投顾优选列表(排行榜)
 */
export function fetchGoodStrategylist(data) {
  return request({
    url: "/v3/recommend_strategies",
    method: "post",
    data: {},
  });
}

/**
 * 获取投顾优选列表(排行榜)-最新
 */
export function fetchGoodStrategylistV3(uid) {
  return request({
    url: `/v3/v2/strategy/list?uid=${uid || ''}`,
    method: "get",
  });
}

/**
 * 获取全部投顾列表(排行榜)
 */
export function fetchAllStrategylist(data) {
  return request({
    url: "/v3/strategies",
    method: "post",
    data,
  });
}

/**
 * 获取 指定 投顾
 *
 */
export function fetchStrategy(sid, day, cid) {
  // https://www.ainvestcn.com/api/office_web/strategy_chart/?strategy_number=3&show_days=1&category_group=1
  const url =
    "/api/office_web/strategy_chart/?strategy_number=" +
    sid +
    "&show_days=" +
    day +
    "&category_group=" +
    cid;
  return request({
    url: url,
    method: "get",
  });
}

/**
 * 获取 指定 投顾 最新
 *
 */
export function fetchStrategyV2(sid, uid) {
  // https://www.ainvestcn.com/api/office_web/strategy_chart/?strategy_number=3&show_days=1&category_group=1
  const url = "/v3/v2/strategy/detail?strategy_id=" + sid + "&uid=" + uid;
  // const url = "/v3/v2/strategy/detail?strategy_id=" + sid + "&uid=18545841678";
  return request({
    url: url,
    method: "get",
  });
}

export function fetchTradeRecordInDetailV2(
  sid,
  uid,
  type,
  start_time,
  end_time
) {
  // const url = `/v3/v2/strategy/trade_history?strategy_id=${sid}&uid=${"18545841678"}&type=${type}&start_time=${start_time}&end_time=${end_time}&page_num=1`;
  const url = `/v3/v2/strategy/trade_history?strategy_id=${sid}&uid=${uid}&type=${type}&start_time=${start_time}&end_time=${end_time}&page_num=1`;
  return request({
    url,
    method: "get",
  });
}

export function fetchAccountTradeRecord(type, start_time, end_time) {
  const url = `/v3/v2/user/user_trade_history?type=${type}&start_time=${start_time}&end_time=${end_time}&page_num=1`;
  return request({
    url,
    method: "get",
  });
}

/**
 * 检测手机号是否占用
 * @param {String} phoneNumber
 */
export function usedphonenumber(phoneNumber) {
  const url = "/v3/usedphonenumber";
  const data = {
    nativeCode: "imAinvestcnabc",
    phoneNumber: phoneNumber,
  };
  return request({
    url: url,
    method: "post",
    data,
  });
}
/**
 * sms code
 * @param {*} phoneNumber
 */
export function getSmsCode(phoneNumber) {
  const url = "/v3/smscode";
  const data = {
    nativeKey: "imAinvestcnabc",
    phoneNumber: phoneNumber,
  };
  return request({
    url: url,
    method: "post",
    data,
  });
}
export function loginsmscode(phoneNumber) {
  const url = "/v3/loginsmscode";
  const data = {
    nativekey: "imAinvestcnabc",
    phonenumber: phoneNumber,
  };
  return request({
    url: url,
    method: "post",
    data,
  });
}
/**
 * 检查验证码
 * @param {String} phoneNumber 手机号
 * @param {String} smscode 验证码
 */
export function ckSmsCode(phoneNumber, smscode) {
  const url = "/v3/verifysmscode";
  const data = {
    nativeCode: "imAinvestcnabc",
    phoneNumber: phoneNumber,
    smsCode: smscode,
  };
  return request({
    url: url,
    method: "post",
    data,
  });
}
/**
 * 用户注册接口
 * @param {
 *  nativeCode:String,
 *  username:String,
 *  phoneNumber:String
 * } data
 */
export function register(data) {
  const url = "/v3/register";
  return request({
    url: url,
    method: "post",
    data,
  });
}

/**
 * 快速注册接口
 * @param {
 *  nativeCode:String,
 *  phone:String,
 *  code:String,
 *  ua:String,
 *  ip:String
 * } data
 */
export function fastReg(data) {
  const url = "/v3/register";
  return request({
    url: url,
    method: "post",
    data,
  });
}

/**
 * 申请星火
 * @param {
 *  nativeCode:String,
 *  username:String,
 *  phoneNumber:String
 * } data
 */
export function applyYidao(data) {
  const url = "/v3/applyyidao";
  return request({
    url: url,
    method: "post",
    data,
  });
}

/**
 * 获取券商列表
 */
export function fetchSecurities() {
  const url = "/v3/securities";
  return request({
    url: url,
    method: "get",
  });
}

/**
 * 获取历史持仓
 */
export function fetchHistory(sid, cid) {
  const url =
    "/api/office_web/new_transaction_record/?strategy_number=" +
    sid +
    "&category_group=" +
    cid;
  return request({
    url: url,
    method: "get",
  });
}
/**
 * 获取历史持仓
 */
export function fetchHistoryWithDate(sid, cid, date) {
  const url =
    "/api/office_web/new_transaction_record/?strategy_number=" +
    sid +
    "&category_group=" +
    cid +
    "&date=" +
    date;
  return request({
    url: url,
    method: "get",
  });
}
/**
 * 获取调仓记录
 */
export function fetchWarehouseHistory(sid, cid) {
  // https://www.ainvestcn.com/api/office_web/adjust_record/?strategy_number=3&category_group=1
  const url =
    "/api/office_web/adjust_record/?strategy_number=" +
    sid +
    "&category_group=" +
    cid;
  return request({
    url: url,
    method: "get",
  });
}
/**
 *
 * @param {*} sid
 * @param {*} cid
 * @param {*} date
 */
export function fetchWarehouseHistoryWithDate(sid, cid, date) {
  // https://www.ainvestcn.com/api/office_web/adjust_record/?strategy_number=3&category_group=1
  const url =
    "/api/office_web/adjust_record/?strategy_number=" +
    sid +
    "&category_group=" +
    cid +
    "&date=" +
    date;
  return request({
    url: url,
    method: "get",
  });
}

/**
 * 申请模拟账号
 */
export function fetchdemoAccount() {
  return request({
    url: "/api/office_web/get_demo_account/",
    method: "get",
  });
}
/**
 *
 */
// 历史持仓
export function fetchTradeRecord() {
  return request({
    url: "/api/office_web/personal_transaction_record/",
    method: "get",
  });
}
// 历史交易
export function fetchAdjustRecord() {
  return request({
    url: "/api/office_web/new_personal_adjust_record/",
    method: "get",
  });
}
// 历史持仓日期查询
export function fetchTradeRecordWithDate(date) {
  return request({
    url: "/api/office_web/personal_transaction_record/?date=" + date,
    method: "get",
  });
}
// 历史交易日期查询
export function fetchAdjustRecordWithDate(date) {
  return request({
    url: "/api/office_web/new_personal_adjust_record/?date=" + date,
    method: "get",
  });
}

export function evtlogadd(evnt, ua, ip, page) {
  const data = {
    phone: "",
    event: evnt,
    ua: ua,
    ipv4: ip,
    page: page,
  };
  return request({
    url: "/v3/addEvtlog",
    method: "post",
    data,
  });
}

export function evtlogadd2(evnt, phone, ua, ip) { }
/**
 * 提交订单检查
 * @param {*} ordernum
 * @param {*} username
 * @param {*} agent
 */
export function addcheck(ordernum, username, agent) {
  const url = "/v3/addcheck";
  const data = {
    nativeCode: "imAinvestcnabc",
    number: ordernum,
    username: username,
    agent: agent,
  };
  return request({
    url: url,
    method: "post",
    data: data,
  });
}
export function isPayTime(username) {
  const url = "/v3/paid";
  const data = {
    nativeCode: "imAinvestcnabc",
    username: username,
  };
  return request({
    url: url,
    method: "post",
    data: data,
  });
}
export function regtime() {
  const url = "api/office_web/registration_time";
  return request({
    url: url,
    method: "get",
  });
}

export function isvipApi(username) {
  const data = {
    nativeCode: "imAinvestcnabc",
    username: username,
  };
  return request({
    url: "/v3/isvip",
    method: "post",
    data,
  });
}
// reg/autoApplymn
export function autoApplymn(sessionid) {
  const data = {
    nativeCode: "imAinvestcnabc",
  };
  return request({
    url: "/v3/autoApplyMon1",
    method: "post",
    data,
  });
}
export function loginv2(phone, code, wxCode, inviteCode, channel) {
  const data = {
    phone_number: phone,
    verify_code: code,
    wx_code: wxCode || '',
    inviteCode: inviteCode || '',
    channel: channel || '',
    platform: 'web',
  };
  return request({
    url: "/api/ainvest_login_new/",
    method: "post",
    data,
  });
}
export function paylog(phone, invitationCode) {
  const data = {
    nativeCode: "nativeCode",
    phone: phone,
    invitationCode: invitationCode,
  };
  return request({
    url: "/v3/paylog",
    method: "post",
    data,
  });
}

export function agentApply(phoneNumber, fullname, inviteByCode) {
  const data = {
    fullname: fullname,
    phoneNumber: phoneNumber,
    inviteByCode: inviteByCode,
  };
  return request({
    url: "/v3/agent/apply",
    method: "post",
    data,
  });
}

/**
 * 切换锁定开关,设置切换比例， 又写一起了，哈哈哈， 留坑
 * @param {string} phone 手机号
 */
export function toggleLockMoney(phone, lockpercent) {
  const data = {
    phone: phone,
    lockpercent: lockpercent,
    nativeCode: "imAinvestcnabc",
  };
  return request({
    url: "/v3/togglelockmoney",
    method: "post",
    data: data,
  });
}

/**
 * 历史记录
 * @param {string} username 手机号
 */
export function history_adjusts(username) {
  const data = {
    username: username,
  };
  return request({
    url: "/v3/history_adjusts",
    method: "post",
    data: data,
  });
}

/**
 * 支付
 * @param {string} username
 * @param {Boolean} isMoble
 * @param {string} alipay
 * @param {string} couponCode
 */
export function pay_vip(data) {
  return request({
    url:
      "/v3/pay_vip?platform=" +
      data.platform +
      "&isMobile=" +
      data.isMobile +
      "&username=" +
      data.username +
      "&couponCode=" +
      data.couponCode +
      "&openId=" +
      data.openId,
    method: "get",
  });
}

export function pay_vip2(data) {
  return request({
    url:
      "/v3/pay_vip2?platform=" +
      data.platform +
      "&isMobile=" +
      data.isMobile +
      "&couponCode=" +
      data.couponCode +
      "&openId=" +
      data.openId,
    method: "get",
  });
}

export function pay_point(data) {
  return request({
    url: "/v3/pay?platform=" + data.platform + "&price=" + data.price,
    method: "get",
  });
}

/**
 * 拿到微信openid
 * @param {string} username
 * @param {Boolean} isMoble
 * @param {string} alipay
 * @param {string} couponCode
 */
export function getWeOpenId(data) {
  return request({
    url: `/v3/wx_openid?code=${data.code}&agentId=${data.agentId}`,
    method: "get",
  });
}

/**
 * 拿到微信openid
 * @param {string} username
 * @param {Boolean} isMoble
 * @param {string} alipay
 * @param {string} couponCode
 */
// export function bindInviteCode(data) {
//   return request({
//     url: "/v3/bind_invite_code",
//     method: "post",
//     data: data,
//   });
// }

/**
 * VIP兑换码兑换
 * @param {String} username 用户名
 * @param {String} code 兑换码
 */
export function exchangeVipCode(username, code) {
  const data = {
    username: username,
    code: code,
    nativeCode: "imAinvestcnabc",
  };
  return request({
    url: "/v3/exchange_vip",
    method: "post",
    data,
  });
}

/**
 * 申请云主机（当前登录用户，服务端从登录态取用户）
 * @returns {Promise} 返回申请结果
 */
export function applyCloudServer() {
  return request({
    url: "/v3/cloud/apply",
    method: "post",
    data: {
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 获取云主机状态（当前登录用户）
 * @returns {Promise} 返回云主机信息
 */
export function getCloudServerStatus() {
  return request({
    url: `/v3/cloud/status?nativeCode=imAinvestcnabc`,
    method: "get",
  });
}

/**
 * 测试Python代码（当前登录用户）
 * @param {Object} data - 请求数据
 * @param {string} data.code - Python代码内容
 * @returns {Promise} 返回测试结果
 */
export function testPythonCode(data) {
  return request({
    url: "/v3/cloud/test",
    method: "post",
    data: {
      ...data,
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 部署Python代码（当前登录用户）
 * @param {Object} data - 请求数据
 * @param {string} data.code - Python代码内容
 * @param {string} data.cloudServerId - 云主机ID
 * @returns {Promise} 返回部署结果
 */
export function deployPythonCode(data) {
  return request({
    url: "/v3/cloud/deploy",
    method: "post",
    data: {
      ...data,
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 关闭云主机（当前登录用户）
 * @returns {Promise} 返回关机操作结果
 */
export function shutdownCloudServer() {
  return request({
    url: "/v3/cloud/shutdown",
    method: "post",
    data: {
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 开启云主机（当前登录用户）
 * @returns {Promise} 返回开机操作结果
 */
export function startupCloudServer() {
  return request({
    url: "/v3/cloud/startup",
    method: "post",
    data: {
      nativeCode: "imAinvestcnabc",
    },
  });
}

/**
 * 充值记录查询（当前登录用户，服务端从登录态取用户）
 * @returns {Promise} 返回充值记录
 */
export function fetchRechargeRecord() {
  const url = `/v3/v2/user/balance_record`;
  return request({
    url,
    method: "get",
  });
}

/**
 * 余额中心（当前登录用户）
 * @returns {Promise} 返回可选套餐
 */
export function fetchBalanceCenter() {
  const url = `/v3/v2/user/balance_center`;
  return request({
    url,
    method: "get",
  });
}

/**
 * @param {string} uid - 用户名
 * @param {string} planId - 兑换id
 */
export function fetchServerTime(uid, planId) {
  const url = `/v3/v2/user/buy_server_time?planId=${planId}&uid=${uid}`;
  return request({
    url,
    method: "get",
  });
}

/** 算力兑换码充值（POST + JSON） */
export function redeemBalanceCode(uid, code) {
  return request({
    url: `/v3/v2/user/redeem_balance_code`,
    method: "post",
    data: { uid, code },
  });
}

/** 兑换码预览：到账算力对应 ¥ 展示（算力×100），不核销 */
export function previewRedeemBalanceCode(uid, code) {
  return request({
    url: `/v3/v2/user/preview_redeem_balance_code`,
    method: "post",
    data: { uid, code },
  });
}

/** 当前登录用户持仓 */
export function fetchUserReturnInfo() {
  const url = `/v3/v2/user/user_position_info`;
  return request({
    url,
    method: "get",
  });
}

export function checkUserIndentity() {
  const url = `/v3/v2/user/check_real_name_auth`;
  return request({
    url,
    method: "get",
  });
}

export function setUserIndentity(data) {
  const url = `/v3/v2/user/set_real_name_auth`;
  return request({
    url,
    method: "post",
    data,
  });
}

/** 当前登录用户信息（不再返回券商交易/通讯密码） */
export function fetchUserIndentity() {
  const url = `/v3/v2/user/user_info`;
  return request({
    url,
    method: "get",
  });
}

// 增加用户券商配置
export function setUserSecuritiesInfo(data) {
  const url = `/v3/v2/user/set_securities_setting`;
  return request({
    url,
    method: "post",
    data,
  });
}
/**
 * @param {string} strategyId - 策略id
 * @param {string} inviteCode - 邀请码
 */
export function fetchUserSubscribeStrategy(strategyId, inviteCode = "") {
  const url = `/v3/v2/user/subscribe_strategy`;
  return request({
    url,
    method: "post",
    data: {
      strategyId,
      inviteCode,
    },
  });
}

/**
 * 生成策略代码（当前登录用户；返回代码内嵌券商凭据，服务端已限定只能生成本人的）
 */
export function genCode() {
  const url = `/v3/cloud/gen`;
  return request({
    url,
    method: "get",
  });
}

/**
 * 创建新的通话会话
 * @param {Object} callData - 通话会话数据
 * @returns {Promise} 返回创建结果
 */
export function createCall(title = "语音通话", chatId = "") {
  return request({
    url: `/v3/chat/create?title=${title}&chatId=${chatId}`,
    method: "post",
  });
}

// 获取用户的通话历史列表
export function getCallList() {
  return request({
    url: "/v3/chat/list",
    method: "get",
  });
}

// 获取特定通话的记录历史
export function getCallTranscripts(chatId) {
  return request({
    url: `/v3/chat/messages?chatId=${chatId}`,
    method: "get",
  });
}

/**
 * 添加通话记录（语音识别和AI回复）
 * @param {*} data {
    "chatId":37,
    "seq":2,
    "msgType":"answer", // question问/answer回答
    "content":"我是回答"
}
 * @returns 
 */

export const addTranscript = async (data) => {
  return request({
    url: ` /v3/chat/message/new`,
    method: "post",
    data,
  });
};

// 获取通话总结
export const getCallSummary = async (callId, history, oldSummary) => {
  return request({
    url: `/call/${callId}/summary`,
    method: "post",
    data: {
      history: history, // 修改为后端期望的格式
      old_summary: oldSummary,
    },
  });
};
// 历史对话列表
export function getIndexData(params) {
  return request({
    // url: `/v3/chat/list?uid=${params.uid}&pageIndex=${params.pageIndex}%pageSize=${params.pageSize}`,
    url: `/v3/chat/list`,
    method: "get",
    params,
  });
}

// 对话详情
export function getIndexDataDetail(chatId) {
  return request({
    url: `/v3/chat/messages?chatId=${chatId}`,
    method: "get",
  });
}

// 提问
export function questionsAndAnswers(params) {
  return request({
    url: `/v3/chat/submit`,
    method: "get",
    params,
  });
}

// 新个人页用户信息接口
// 服务端从 access_token Cookie 里解出当前用户（Java @NeedLogin），不再接受 uid 参数，
// 避免任意用户名即可读取他人余额/持仓/券商账户的越权问题。
export function userInfoDetail() {
  return request({
    url: `/v3/v2/user/user_detail`,
    method: "get",
  });
}

/**
 * 更新用户签约状态（当前登录用户）
 * @returns {Promise} 返回更新结果
 */
export function updateUserSignStatus(type) {
  return request({
    url: `/v3/v2/user/update_user_sign_status?type=${type}`,
    method: "get",
  });
}

/**
 * 更新用户访问状态（当前登录用户）
 * @param {{type: number|string}} params
 * @returns {Promise} 返回更新结果
 */
export function updateUserVisitStatus(params) {
  const { type } = params;
  return request({
    url: `/v3/v2/user/update_user_visit_status?type=${type}`,
    method: "get",
  });
}

export function getOrderInfo(orderId) {
  return request({
    url: `/v3/order/status?orderId=${orderId}`,
    method: "get",
  });
}

// 合伙人
export function partnershipInfo() {
  return request({
    url: `/v3/v2/user/partner_info`,
    method: "get",
  });
}

/**
 * 获取实名认证页面地址
 */
export function getRealNameAuthUrl() {
  return request({
    url: `/v3/v2/user/detect_url?redirect_url=${encodeURIComponent(
      window.location.href
    )}`,
    method: "get",
  });
}

/**
 * 查询实名认证结果
 */
export function getRealNameAuthResult(biz_token) {
  return request({
    url: `/v3/v2/user/get_detect_res?biz_token=${biz_token}`,
    method: "get",
  });
}
